import React from 'react';
import PaymentLinkTable from './_components/table';
import { Link } from 'react-router-dom';
import { HiOutlinePlus, HiOutlineRefresh } from 'react-icons/hi';

function PaymentLinks() {
  const [refreshKey, setRefreshKey] = React.useState(0);

  return (
    <div>
      {/* Page header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 24,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: '#111827',
              margin: 0,
            }}
          >
            Payment Links
          </h1>
          <p style={{ fontSize: 13, color: '#6B7280', marginTop: 4, marginBottom: 0 }}>
            Manage all payment links
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => setRefreshKey((k) => k + 1)}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#374151',
              backgroundColor: '#fff',
              border: '1px solid #E5E7EB',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <HiOutlineRefresh size={14} /> Refresh
          </button>
          <Link
            to='/payment-links/create-new-payment-link'
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#fff',
              backgroundColor: '#4F46E5',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(79,70,229,0.25)',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              textDecoration: 'none',
            }}
          >
            <HiOutlinePlus size={14} /> Create Link
          </Link>
        </div>
      </div>

      {/* Table */}
      <PaymentLinkTable refreshKey={refreshKey} />
    </div>
  );
}

export default PaymentLinks;
